import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Upload,
  Button,
  Modal,
  message,
  Tag,
  notification,
} from 'antd'
import '../../styleLess/signature/myprofile.scss'
import {
  CameraFilled,
  CloseCircleOutlined,
  EditFilled,
  EyeInvisibleOutlined,
  EyeOutlined,
  FrownOutlined,
  HourglassOutlined,
  InfoCircleOutlined,
  MailOutlined,
  SmileOutlined,
} from '@ant-design/icons'

import {
  GET_DATA_ACCOUNT_BY_ID,
  POST_ACCOUNT_PASSWORD,
  POST_ACCOUNT_ROLE,
  POST_ACCOUNT_IMAGE,
} from 'api/Account/profile'
import { getCookie, setCookie } from 'helper/cookie'
import { CounterContext } from 'redux/Golbalvalues'

import { PasswordInput } from 'antd-password-input-strength'
import zxcvbn from 'zxcvbn'
import { Helmet } from 'react-helmet'
import { getCompanyLink } from 'api/MasterData/userManagement'
import { getFileSecurityFromApi } from 'api/OpenFile'
const Myprofilecontainer = styled.div``

const EditUpload = styled(Upload)``
const initialState = {
  data: [],
}
var der_phone = ''
const myprofile = () => {
  const { addCounter, getPermissionAdmin } = useContext(CounterContext)
  const [state, setState] = useState('')
  const [logoName, setlogoName] = useState('')
  const [ercode, setErcode] = useState(String || '')
  const [form1] = Form.useForm()
  const [form2] = Form.useForm()
  const [stateUse, setStateUse] = useState(true)
  const { imageUrl } = state
  const [focus, setFocus] = useState(0)
  const token = getCookie('access_token_admin')
  const userID = getCookie('userID')
  const [dataAccount, setDataAccount] = useState(initialState.data)
  const [enableroleinput, setEnableroleinput] = useState(true)
  const [modalshow, setModalshow] = useState(false)
  const [modalErrpass, setModalErrpass] = useState(false)
  const [disableSave, setDisableSave] = useState(false)
  const [scorePassword, setScorePassword] = useState({ nameScore: '', colorScore: '' })

  const normalizeCompanyLinkItem = (item = {}) => {
    return {
      ...item,
      company_name_en: item.company_name_en || item.companyname_en || item.name_en || '',
      company_name_th: item.company_name_th || item.companyname_th || item.name_th || '',
    }
  }

  const onChangePassword = (e) => {
    let value = e.target.value
    let score = value.length == 0 ? -1 : zxcvbn(value).score

    if (score == -1) {
      setScorePassword({ nameScore: '', colorScore: '' })
    } else if (score == 0) {
      setScorePassword({ nameScore: 'Weak', colorScore: 'rgb(255, 64, 51)' })
    } else if (score == 1) {
      setScorePassword({ nameScore: 'Okay', colorScore: 'rgb(254, 148, 13)' })
    } else if (score == 2) {
      setScorePassword({ nameScore: 'Good', colorScore: 'rgb(255, 217, 8)' })
    } else if (score == 3) {
      setScorePassword({ nameScore: 'Strong', colorScore: 'rgb(203, 225, 29)' })
    } else if (score == 4) {
      setScorePassword({ nameScore: 'Stronger', colorScore: 'rgb(110, 204, 58)' })
    }

    if (score < 3) {
      setDisableSave(true)
    } else {
      setDisableSave(false)
    }
  }

  const funcGETaccountbyID = async () => {
    await GET_DATA_ACCOUNT_BY_ID({
      id: parseInt(userID),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        const accountData = data?.result || data

        if (error) {
          await setDataAccount([])
          return true
        }
        if (status === 200 && accountData) {
          if (accountData.pic_display != undefined && accountData.pic_display != '') {
            const response1 = await getFileSecurityFromApi({
              url: accountData.pic_display,
              token,
            }).then((res) => res.data)
            const blobUrl = URL.createObjectURL(response1)
            setState({
              imageUrl: blobUrl,
            })
          }

          const findCompanyLink = await fetchApiCompanyLink(accountData.id)
          const joinData = {
            ...accountData,
            company_list: findCompanyLink,
          }
          setDataAccount(joinData)
          // console.log(data)
          form1.setFieldsValue({
            username: accountData.username,
            name_en: accountData.firstname,
            lastname_en: accountData.lastname,
            name_th: accountData.firstname_th,
            lastname_th: accountData.lastname_th,
            // bu: data.bu_user,
            phone: accountData.phone,
            default_role: accountData.role_id,
            main_company_name: accountData.main_company_name,
            company_group: accountData.bu_user,
          })
          der_phone = accountData.phone
          funcRoleController(accountData.canbe_role, accountData.canbe_rolename)
        } else {
          setDataAccount([])
          return true
        }
      })
      .catch((error) => {
        setDataAccount([])

        console.error(error)
      })
  }
  const fetchApiCompanyLink = async (id) => {
    const getdata = await getCompanyLink({
      token,
      id,
    })
      .then(async (response) => {
        if (Array.isArray(response)) {
          return response.map((item) => normalizeCompanyLinkItem(item))
        }

        const { status, data } = response || {}
        if (status !== 200) {
          return []
        }

        if (Array.isArray(data)) {
          return data.map((item) => normalizeCompanyLinkItem(item))
        }

        if (Array.isArray(data?.result)) {
          return data.result.map((item) => normalizeCompanyLinkItem(item))
        }

        return []
      })
      .catch((error) => {
        console.error(error)
        return []
      })

    return getdata
  }
  useEffect(() => {
    if (token) {
      window.scrollTo(0, 0)
      funcGETaccountbyID()
    }
  }, [token])
  const [options, setOptions] = useState([])
  const funcRoleController = (valueID, valName) => {
    let newValueID = valueID.split(',')
    let newValName = valName.split(',')

    let arrayId = []
    newValueID.map((item, index) => {
      if (item != '') {
        arrayId.push(item)
      }
    })
    let arr = []
    newValName.map((iName, indexN) => {
      let j = {
        id: parseInt(arrayId[indexN]),
        name: iName,
      }
      arr.push(j)
    })
    setOptions(arr)
    form1.setFieldsValue({
      role: arr.map((item) => {
        return item.name
      }),
    })
  }
  const tagRender = (props) => {
    const { label, value, closable, onClose } = props
    const onPreventMouseDown = (event) => {
      event.preventDefault()
      event.stopPropagation()
    }
    return <Tag style={{ marginRight: 4 }}>{label}</Tag>
  }
  const openNotification = (val) => {
    if (val === 'success') {
      notification.open({
        message: 'Change Password Success ',
        description:
          '  You have successfully changed your password. You will still be able to stay logged in. until you log out.  ',
        icon: <SmileOutlined style={{ color: '#127ec3' }} />,
      })
    } else {
      notification.open({
        message: 'Change Password Fail',
        description: ' Please make sure your old password is correct.',
        icon: <FrownOutlined style={{ color: '#d21419' }} />,
      })
    }
  }

  const logoUpload = (file) => {
    const data = new FormData()
    data.append('uploadfile', file)
    data.append('account_id', parseInt(userID))
    try {
      POST_ACCOUNT_IMAGE({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          addCounter(1)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      // message.error('Image must smaller than 2MB!')
    }
    return isJpgOrPng && isLt2M
  }

  function getBase64(img, callback) {
    if (img != undefined) {
      const reader = new FileReader()
      reader.addEventListener('load', () => callback(reader.result))
      reader.readAsDataURL(img)
    }
  }
  const handleChange = (info) => {
    getBase64(info.file.originFileObj, (imageUrl) =>
      setState({
        imageUrl,
      }),
    )

    setlogoName(info.file.name)
  }

  const RendererFunctional = (state, val) => {
    if (state === false) {
      setStateUse(false)
      if (val === 1) {
        form2.resetFields()
      }
      setFocus(val)
      setEnableroleinput(false)
      setDisableSave(false)
    } else {
      setStateUse(true)
      setFocus(0)
      setEnableroleinput(true)
      form1.setFieldsValue({
        phone: der_phone,
      })
    }
  }

  const uploadButton = (
    <div className="camera-button" style={{ display: 'flex', alignItems: 'center' }}>
      <CameraFilled className="icon" />
    </div>
  )

  const onFinishPersonal = (val) => {
    setStateUse(true)
    setFocus(0)
    setEnableroleinput(true)
    const data = {
      id: parseInt(userID),
      default_role: `${val.default_role}`,
      canbe_role: dataAccount.canbe_role,
      phone: val.phone,
    }
    try {
      POST_ACCOUNT_ROLE({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          setCookie('roleUser', parseInt(res.data.default_role))
          setCookie('roleNameDefault', res.data.default_rolename)
          der_phone = val.phone
          getPermissionAdmin()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const Subcomponents_Personal_detail = () => {
    return (
      <Form
        form={form1}
        layout="vertical"
        className="form-style-container"
        onFinish={onFinishPersonal}
      >
        <Row className="row-custom">
          <Col style={{ width: '100%' }}>
            <Form.Item name="username" className="disable-page" label={<h4>Username</h4>}>
              <Input
                readOnly
                size="large"
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} className="row-custom">
          <Col span={12} style={{ marginBottom: '24px' }}>
            <Form.Item name="name_th" className="disable-page" label={<h4>Name (TH)</h4>}>
              <Input
                readOnly
                size="large"
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ marginBottom: '24px' }}>
            <Form.Item
              name="lastname_th"
              className="disable-page"
              label={<h4>Lastname (TH)</h4>}
            >
              <Input
                readOnly
                size="large"
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="name_en" className="disable-page" label={<h4>Name (EN)</h4>}>
              <Input
                readOnly
                size="large"
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="lastname_en"
              className="disable-page"
              label={<h4>Lastname (EN)</h4>}
            >
              <Input
                readOnly
                size="large"
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} className="row-custom">
          <Col span={12}>
            <Form.Item
              label="Main Company Name"
              className="disable-page"
              name="main_company_name"
              style={{ fontSize: '16px' }}
            >
              <Input
                readOnly
                size="large"
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Company Group"
              className="disable-page"
              name="company_group"
              style={{ fontSize: '16px' }}
            >
              <Input
                readOnly
                size="large"
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="row-custom">
          <Col style={{ width: '100%' }}>
            <Form.Item name="role" label={<h4>Role</h4>}>
              <Select
                className="tag-custom-style"
                size="large"
                mode="multiple"
                readOnly
                tagRender={tagRender}
                style={{ width: '100%' }}
                // disabled={enableroleinput}
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="row-custom">
          <Col style={{ width: '100%' }}>
            <Form.Item name="default_role" label={<h4>Default Role</h4>}>
              <Select
                value={dataAccount.role}
                className="tag-custom-style"
                size="large"
                style={{ width: '100%' }}
                disabled={enableroleinput}
              >
                {options.map((item) => (
                  <Option key={item.id} value={item.id} data={item}>
                    <div className="container-in-input">
                      <div className="box-tag">{item.name}</div>
                    </div>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row className="row-custom">
          <Col style={{ width: '100%' }}>
            <Form.Item
              name="phone"
              className="disable-page"
              label={<h4>Phone</h4>}
              rules={[
                {
                  required: !enableroleinput,
                  message: 'Please enter your phone number 0-9',
                  pattern: new RegExp(/^[0-9]+$/),
                  min: 10,
                  whitespace: true,
                },
              ]}
            >
              <Input
                disabled={enableroleinput}
                minLength={5}
                maxLength={10}
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
  const renderskillname = (val) => {
    if (val != undefined) {
      var newVal = val.split(',')
      if (newVal != undefined) {
        return newVal?.map((item) => {
          if (item != '') {
            return <p>{item}</p>
          }
        })
      }
    }
  }
  const rendercompanylink = (array) => {
    return array?.map((item) => (
      <p className="tagstyle" key={item.company_id || item.company_code || item.id}>
        {item.company_name_en || item.company_name_th || '-'}
      </p>
    ))
  }
  const [memoryPass, setMemorypass] = useState()
  const onFinishChangePassword = (val) => {
    setModalshow(true)
    setMemorypass(val)
  }
  const onOkmodalpass = () => {
    setModalshow(false)
    setStateUse(true)
    setFocus(0)
    setEnableroleinput(true)
    const data = {
      account_id: parseInt(userID),
      old: memoryPass.current_password,
      new: memoryPass.confirm_password,
      role_id: dataAccount.role_id,
      page: 'profile',
    }
    try {
      POST_ACCOUNT_PASSWORD({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          setMemorypass()
          openNotification('success')
        } else {
          setErcode(res.data.errorCode)
          setModalErrpass(true)
        }
        form2.resetFields()
      })
    } catch (error) {
      console.log(error)
    }
  }
  const onCancelmodalpass = () => {
    setModalshow(false)
  }

  const validatePassword = (_, value, callback) => {
    const validList = [
      {
        pattern: '.{10,}',
        message: 'Password must be at least 10 characters.',
      },
      {
        pattern: '.*(\\d{1,}).*',
        message: 'Password must have at least 1 digit',
      },
      {
        pattern: '.*([a-z]{1,}).*',
        message: 'Password must have at least 1 lower case character',
      },
      {
        pattern: '.*([A-Z]{1,}).*',
        message: 'Password must have at least 1 upper case character',
      },
      {
        pattern: '(?=.*?[#?!@_$%^&*-])',
        message: 'Password must have at least 1 special character',
      },
    ]

    validList.forEach((regex) => {
      if (value && !value.match(regex.pattern)) {
        callback(regex.message)
      }
    })
    callback()
  }

  const Subcomponents_Change_password = () => {
    return (
      <Form
        form={form2}
        layout="vertical"
        className="form-style-container"
        onFinish={onFinishChangePassword}
      >
        <Row gutter={16}>
          <Col style={{ width: '100%', marginBottom: '24px' }}>
            <Form.Item
              name="current_password"
              label={<h4>Current Password</h4>}
              rules={[{ required: true, message: 'Please enter current password !' }]}
              onChange={(e) =>
                form2.setFieldsValue({
                  current_password: e.target.value.replace(/\s/g, ''),
                })
              }
            >
              <Input.Password
                className="input-style-custom"
                placeholder="Please enter current password"
                iconRender={(visible) =>
                  visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col
            style={{ width: '100%', marginBottom: '24px' }}
            className="style-message-new-password"
          >
            <Form.Item
              name="new_password"
              label={
                <Row
                  style={{
                    width: '100%',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ marginRight: 8 }}>
                    <h4>New Password</h4>
                  </div>
                </Row>
              }
              rules={[
                {
                  required: true,
                  message: 'Please enter new password !',
                  whitespace: true,
                },
                {
                  validator: validatePassword,
                },
              ]}
            >
              <PasswordInput
                placeholder="Please enter new password"
                onChange={(e) => {
                  onChangePassword(e)
                }}
              />
            </Form.Item>
            <p
              style={{
                color: scorePassword.colorScore,
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: scorePassword.nameScore != '' ? -10 : 0,
              }}
            >
              {scorePassword.nameScore}
            </p>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col style={{ width: '100%' }} className="style-message-confirm-password">
            <Form.Item
              name="confirm_password"
              label={<h4>Confirm Password</h4>}
              dependencies={['new_password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password !',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('new_password') === value) {
                      return Promise.resolve()
                    }

                    return Promise.reject(
                      new Error('The two passwords that you entered do not match!'),
                    )
                  },
                }),
              ]}
              onChange={(e) =>
                form2.setFieldsValue({
                  confirm_password: e.target.value.replace(/\s/g, ''),
                })
              }
            >
              <Input.Password
                className="input-style-custom"
                placeholder="Please enter confirm password"
                iconRender={(visible) =>
                  visible ? <EyeOutlined /> : <EyeInvisibleOutlined className="eye-2" />
                }
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
  const okErrpass = () => {
    setModalErrpass(false)
  }

  return (
    <Myprofilecontainer className="container-myprofile">
      <Helmet>
        <title>AXONS PROJECT | My Profile</title>
      </Helmet>
      <div className="header-myprofile">
        <h1>My Profile</h1>
      </div>
      <div className="content-myprofile">
        <div className="left-content">
          <div>
            <div className="image-container">
              <img className="img-items" src={imageUrl}></img>
            </div>
            <EditUpload
              className="edit-upload-profile"
              action={logoUpload}
              name="uploadfile"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
            >
              {imageUrl ? (
                <div
                  className="camera-button"
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CameraFilled className="icon" />
                </div>
              ) : (
                uploadButton
              )}
            </EditUpload>
          </div>

          <div className="user-detail-content">
            <div style={{ display: 'grid' }}>
              <h1 className="cutter-text-line-1">
                {dataAccount.firstname}
                {'  '}
                {dataAccount.lastname}
              </h1>
            </div>
          </div>

          <div className="user-company-container">
            <h3>Business</h3>
            <div style={{ display: 'grid' }}>
              <h4 className="cutter-text-line-1">{dataAccount.companyname_en}</h4>
            </div>
          </div>

          <div className="user-operation-container">
            <div className="box-oper">
              <h3>Operation</h3>
              <div style={{ display: 'grid' }}>
                <h4 className="cutter-text-line-1">
                  {dataAccount.operationname_en != ''
                    ? dataAccount.operationname_en
                    : 'no operation'}
                </h4>
              </div>
            </div>
            <div className="box-oper">
              <h3>Project type</h3>
              <div style={{ display: 'grid' }}>
                <h4 className="cutter-text-line-1">
                  {dataAccount.suboperationname_en !== ''
                    ? dataAccount.suboperationname_en
                    : 'no project type'}
                </h4>
              </div>
            </div>
          </div>
          <div className="user-companylink-content">
            <h3>Link Business</h3>
            <Col className="area-skill-tag">
              {Array.isArray(dataAccount?.company_list) &&
              dataAccount.company_list.length !== 0 ? (
                rendercompanylink(dataAccount?.company_list)
              ) : (
                <h4 style={{ color: '#7C7C84' }}>no link company</h4>
              )}
            </Col>
          </div>
          <div className="user-profile-content">
            <h3>Skills</h3>
            <Col className="area-skill-tag">
              {dataAccount.skill_name != '' ? (
                renderskillname(dataAccount.skill_name)
              ) : (
                <h4 style={{ color: '#7C7C84' }}>This user has no skills</h4>
              )}
            </Col>
            <Row className="style-row" align="middle">
              <MailOutlined className="mail-ant-custom" />
              <span className="mediumtext">{dataAccount.email}</span>
            </Row>
            <Row className="style-row" align="middle">
              <HourglassOutlined className="hoursglass-ant-custom" />
              <span className="mediumtext">Last logged in: {dataAccount.lastlogin}</span>
            </Row>
          </div>
        </div>
        <div className="right-content">
          <div>
            {stateUse === true ? (
              <Row justify="space-between" className="row-btn-responsive-editprofile">
                <h2>Personal details</h2>
                <Button
                  type="primary"
                  className="BTN_Next"
                  onClick={() => RendererFunctional(false, 0)}
                >
                  <EditFilled className="Icon-color" />
                  Edit Profile
                </Button>
              </Row>
            ) : (
              <div className="crory-tab">
                <Row className="tab">
                  <div
                    className={focus === 0 ? 'Tabbar' : 'active-Tabbar'}
                    onClick={() => RendererFunctional(false, 0)}
                  >
                    <h3>Personal detail</h3>
                  </div>
                  <div
                    className={focus === 1 ? 'Tabbar' : 'active-Tabbar'}
                    onClick={() => RendererFunctional(false, 1)}
                  >
                    <h3>Change password</h3>
                  </div>
                </Row>
              </div>
            )}

            {focus === 0 ? (
              <div className="container-form">
                <div style={{ width: '100%' }}>{Subcomponents_Personal_detail()}</div>
              </div>
            ) : (
              <div className="container-form">
                <div style={{ width: '100%' }}> {Subcomponents_Change_password()}</div>
              </div>
            )}
          </div>

          {focus === 0 ? (
            stateUse === false ? (
              <Row justify="end" className="btn-container">
                <Button
                  style={{ marginRight: 8 }}
                  type="primary"
                  className="BTN_Previous"
                  onClick={() => RendererFunctional(true)}
                >
                  Cancel
                </Button>
                <Button type="primary" className="BTN_Next" onClick={form1.submit}>
                  Save
                </Button>
              </Row>
            ) : (
              <Row></Row>
            )
          ) : (
            <Row justify="end" className="btn-container">
              <Button
                style={{ marginRight: 8 }}
                type="primary"
                className="BTN_Previous"
                onClick={() => RendererFunctional(true)}
              >
                Cancel
              </Button>
              <Button
                disabled={disableSave}
                type="primary"
                className="BTN_Next"
                onClick={form2.submit}
              >
                Save
              </Button>
            </Row>
          )}
        </div>
      </div>
      <Modal
        visible={modalshow}
        onOk={onOkmodalpass}
        onCancel={onCancelmodalpass}
        className="ModalStatusOption"
        okText={'Confirm'}
      >
        <InfoCircleOutlined className="infocircleoutlined " />
        <h2>Change password</h2>
        <h4>Are you sure you want to change password?</h4>
      </Modal>
      <Modal
        visible={modalErrpass}
        onOk={okErrpass}
        className="ModalSaveDraft"
        okText={'Ok'}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>Something went wrong</h2>
        <h4 style={{ marginTop: 16 }}>
          {ercode === '2012'
            ? 'The new password cannot be same as current password.'
            : ercode === '2007'
              ? 'The current password is incorrect.'
              : 'The password is too easy to guess.'}
        </h4>
        <h4 style={{ marginTop: 0 }}>Please try again.</h4>
      </Modal>
    </Myprofilecontainer>
  )
}
export default myprofile
